module.exports = __webpack_public_path__ + "img/france.968aaa24.svg";